import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormHelperText,
    Grid,
    Typography,
    TextField
} from "@mui/material"
import { useTranslation } from "react-i18next"
import { makeStyles } from "@mui/styles"
import React, { useEffect } from "react"

import RedStarRequired from "../../components/RedStarRequired"
import { ReactComponent as AlertRed } from "../../icons/alert-red.svg"

const EditSectionDialog = (props) => {
    const { t } = useTranslation()
    const { data, doSaveEditSection, open } = props

    const [shortDescTH, setShortDescTH] = React.useState("")
    const [shortDescEN, setShortDescEN] = React.useState("")
    const [endDays, setEndDays] = React.useState("")
    const [isShortDescEnValid, setIsShortDescEnValid] = React.useState(false)
    const [isShortDescThValid, setIsShortDescThValid] = React.useState(false)
    const [isEndDateValid, setIsEndDayValid] = React.useState(false)
    const [isEndDateIntergerOnly, setIsEndDateIntergerOnly] = React.useState(false)
    const changeDescEN = (val) => {
        setShortDescEN(val)
    }
    const changeDescTH = (val) => {
        setShortDescTH(val)
    }
    const changeEndDays = (val) => {
        val = val.replace(/^0+/, '')
        setEndDays(val)
    }
    const handleClose = (_, reason = null) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") props.setValue(false)
    }

    const handleSave = () => {
        if (isShortDescEnValid && isShortDescThValid && isEndDateValid) {
            let result = {
                descEN: shortDescEN,
                descTH: shortDescTH,
                endDays: endDays,
                seq: data.seq,
                stepType: data.stepType,
                id: data?.id
            }
            doSaveEditSection(result)
        }
    }

    const ErrorHelper = (props) => {
        const { t } = useTranslation();
        const { text } = props
        return (
            <Grid container mt={0}>
                <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
                    <AlertRed />
                    <FormHelperText
                        error={true}
                        sx={{ ml: 1 }}
                    >
                        {
                            !text ? t("label.pleaseFillOutThisField") : text
                        }
                    </FormHelperText>
                </Grid>
            </Grid>)
    }

    // useEffect
    useEffect(() => {
        if (data?.descriptionEN) {
            setShortDescEN(data.descriptionEN)
        }

        if (data?.descriptionTH) {
            setShortDescTH(data.descriptionTH)
        }

        if (data?.days) {
            setEndDays(data.days)
        }
    }, [data])

    useEffect(() => {
        if (shortDescEN !== "" && shortDescEN.length <= 20) {
            setIsShortDescEnValid(true)
        } else {
            setIsShortDescEnValid(false)
        }
    }, [shortDescEN])

    useEffect(() => {
        if (shortDescTH !== "" && shortDescTH.length <= 20) {
            setIsShortDescThValid(true)
        } else {
            setIsShortDescThValid(false)
        }
    }, [shortDescTH])

    useEffect(() => {
        let n = Math.floor(Number(endDays))
        // check if integer only (can't be float)
        let isIntergerOnly = (/^\d+$/).test(endDays)
        setIsEndDateIntergerOnly(isIntergerOnly)
        if (n !== Infinity && n > 0 && isIntergerOnly) {
            setIsEndDayValid(true)
        } else {
            setIsEndDayValid(false)
        }
    }, [endDays])

    useEffect(() => {
        if (!open) setEndDays("")
    }, [open])


    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={handleClose}
                disableEscapeKeyDown={true}
                maxWidth="xs"
                fullWidth={true}
                PaperProps={{ sx: { p: "20px" } }}
                aria-labelledby="edit-section-dialog"
                aria-describedby="edit-section-dialog-desc"
            >
                <DialogTitle sx={{ m: 0, p: "0 0 12px 0" }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                            p: 0,
                            m: 0,
                            width: "100%",
                        }}
                    >
                        <Typography fontSize="24px" fontWeight="600" color="#404349">
                            {t("adminWorkflow.dialog.editShortDescription")}
                        </Typography>
                        <Typography
                            color="#404349"
                            style={{ cursor: "pointer" }}
                            sx={{ ml: "auto" }}
                            onClick={() => handleClose()}
                        >
                            X
                        </Typography>
                    </Box>
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ p: 0 }}>
                    <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
                        <Grid container mt={2}>
                            <Grid item display="flex">
                                <Typography color={"#404349"} fontSize="18px" fontWeight="500" sx={{ mr: 1 }}>{t("adminWorkflow.dialog.shortDescEN")}</Typography>
                                <RedStarRequired />
                            </Grid>
                            <Grid item display="flex" ml="auto" alignItems="flex-end">
                                <Typography color={shortDescEN.length <= 20 ? "#D8D8D8" : "#CC6058"} fontSize="14px" fontWeight="400" sx={{ mr: 1 }}>{`${shortDescEN.length}/20`}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container mt={1}>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-basic"
                                    error={shortDescEN.length === 0 || shortDescEN.length > 20}
                                    placeholder={t("adminWorkflow.dialog.fillShortDescEN")}
                                    value={shortDescEN}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    onChange={(e) => changeDescEN(e.target.value)}
                                />
                                {!isShortDescEnValid && shortDescEN.length === 0 && <ErrorHelper />}
                            </Grid>
                        </Grid>
                        <Grid container mt={2}>
                            <Grid item display="flex">
                                <Typography color={"#404349"} fontSize="18px" fontWeight="500" sx={{ mr: 1 }}>{t("adminWorkflow.dialog.shortDescTH")}</Typography>
                                <RedStarRequired />
                            </Grid>
                            <Grid item display="flex" ml="auto" alignItems="flex-end">
                                <Typography color={shortDescTH.length <= 20 ? "#D8D8D8" : "#CC6058"} fontSize="14px" fontWeight="400" sx={{ mr: 1 }}>{`${shortDescTH.length}/20`}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container mt={1}>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-basic"
                                    error={shortDescTH.length === 0 || shortDescTH.length > 20}
                                    placeholder={t("adminWorkflow.dialog.fillShortDescTH")}
                                    value={shortDescTH}
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => changeDescTH(e.target.value)}
                                    size="small"
                                />
                                {!isShortDescThValid && shortDescTH.length === 0 && <ErrorHelper />}
                            </Grid>
                        </Grid>
                        <Grid container mt={2}>
                            <Grid item display="flex">
                                <Typography color={"#404349"} fontSize="18px" fontWeight="500" sx={{ mr: 1 }}>{t("adminWorkflow.dialog.endDate")}</Typography>
                                <RedStarRequired />
                            </Grid>
                        </Grid>
                        <Grid container mt={1}>
                            <Grid item xs={2}>
                                <TextField
                                    id="outlined-basic"
                                    value={endDays}
                                    error={!isEndDateValid}
                                    placeholder="0"
                                    variant="outlined"
                                    size="small"
                                    onChange={(e) => changeEndDays(e.target.value)}
                                    sx={{ width: "70px", "& input": { textAlign: "center" } }}
                                />
                            </Grid>
                            <Grid item xs="auto" ml={2} display="flex" justifyContent="center" alignItems="center">
                                <Typography color={"#404349"} fontSize="16px" fontWeight="400">{t("adminWorkflow.dialog.daysFromEmployeeStartDate")}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                {
                                    (!isEndDateValid && endDays.length === 0)  ? <ErrorHelper /> :
                                    (!isEndDateValid && isNaN(Number(endDays)) || !isEndDateIntergerOnly) ? <ErrorHelper text={t("adminWorkflow.dialog.mustBeInteger")} /> :
                                    (!isEndDateValid && Number(endDays) < 0) ? <ErrorHelper text={t("adminWorkflow.dialog.mustBePositiveValue")} /> : <></> 
                                }
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0, pb: 1, mt: 2 }}>
                    <Button onClick={handleSave} size="large" variant="contained" sx={{ width: '150px', height: "45px", textTransform: "none" }} color="primary" disabled={!isShortDescEnValid || !isShortDescThValid || !isEndDateValid}>{t(`label.save`)}</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};
export default EditSectionDialog;
